import React, { Component } from 'react';
import './App.css';
import HistoryList from './history/HistoryList';
import LoginOptions from './loginredirection/LoginOptions';
import PrcWrapper from './loginredirection/PrcWrapper';
import Order from './Order';
import 'date-input-polyfill';
import {
	Route,
	Switch
} from 'react-router-dom';
import { getAccountType } from './util/apiUtils';
import PdfViewer from './components/PdfViewer';
import PatientManagementHome from './patient-management/PatientManagementHome';
import LandingPage from './landing-page/LandingPage';
import Recollection from './Recollection';
import PITLLandingPage from './phsycian-in-the-loop/PITLLandingPage';
import ConnectRememberMe from './phsycian-in-the-loop/rememberMeUtil';
import ManageBundles from './bundle/manage/ManageBundles';

class App extends Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			loading: false,
			showError: false,
			errorMsg: '',
			userInfo: null,
			step: 'start',
			initialized: false,
			dateOfBirth: null,
			redirect: null
		};

		this.setDateOfBirth = this.setDateOfBirth.bind(this);
		this.setLoading = this.setLoading.bind(this);
		this.setStep = this.setStep.bind(this);
		this.setSearchMessage = this.setSearchMessage.bind(this);
		this.showError = this.showError.bind(this);

		window._fetch = window.fetch;
		window.fetch = (input, init) => {
			if (this.state.showError) {
				this.setState({
					showError: false,
					errorMsg: ""
				});
			}
			let accType = this.state.userInfo ? '/' + this.state.userInfo.type : '';
			return window._fetch(process.env.REACT_APP_GDX_WEB_URL + "/mygdx/account/JWT" + accType, {
				credentials: 'include',
				cache: 'no-store'
			})
			.then(response => {
				if (response.redirected) {
					window.location = response.url;
				} else {
					if (input!=null){
						// default init param and headers - not all calling code includes them
						init = init || {};
						init.headers = init.headers || {};
						init.headers["access-token"] = response.headers.get("access-token");
						return window._fetch(input, init);
					}
				}
			});
		};

		this.keepAliveTimeout = null;
	}

	componentDidMount() {
		getAccountType()
		.then(json => {
			if (json) {
				this.setState({
					userInfo: json,
					initialized: true
				});
			}
		})
		.catch(e => {
			// If the request returned Unauthorized, redirect to the login page
			if (e.response && e.response.status === 401) {
				if (
					window.location.hash &&
					(window.location.hash.startsWith('#/register') ||
						window.location.hash.includes('/connect') ||
						ConnectRememberMe.isReturningVisit())
				) {
					// Don't redirect for '#/register' or '#/order/connect'
					/* We do these checks in the catch (instead of before the getAccountType() call)
					 * because we want to use the signed-in account if one is available, we just don't
					 * want to redirect to /login if one is not available.
					 */
					this.setUserInfo({
						type: 'prc'
					});
				} else {
					this.setState({
						redirect: encodeURIComponent(window.location.href)
					});
					
					window.location.hash = "/login";
					return;
				}
			} else {
				this.showError('The network is currently unavailable. Please call us at 800-522-4762.');
			}
		})
		.finally(() => {
			this.setState({
				initialized: true
			});
		});

		if (!this.keepAliveTimeout) {
			this.keepAliveTimeout = setInterval(() => {
				this.ajaxKeepAlive();
			}, 1000 * 60 * 20); // 20 minutes
		}
	}

	componentWillUnmount() {
		if (this.keepAliveTimeout) {
			clearInterval(this.keepAliveTimeout);
		}
	}

	/**
	 * Execute a server request to keep the session alive.
	 * TODO: Improve this to a session timeout warning that lets the user confirm they are still working.
	 */
	ajaxKeepAlive = () => {
		// TODO: Hit a server endpoint and read the response to check if the session exists. If not, show a timeout error (Could happen on server restarts)
		window._fetch(`${process.env.REACT_APP_GDX_WEB_URL}/html/ping.html`, {
			credentials: 'include',
			cache: 'no-store'
		});
	}
	setLoading(b) {
		if (this.state.loading !== b) {
			this.setState({loading: b});
		}
	}
	setRequisitionResponse(o) {
		this.setState({reqResponses: o});
	}
	setRequisitionStructure(o) {
		this.setState({reqStructure: o});
	}
	setStep(o) {
		this.setState({step: o});
	}
	setSearchMessage(m) {
		this.setState({searchMessage: m});
	}

	setUserInfo = (userInfo) => {
		this.setState({ userInfo: userInfo });
	}
	
	/**
	 * Sets the patient date of birth for the requisition search.
	 */
	setDateOfBirth(dateOfBirth, callback) {
		this.setState({
			dateOfBirth: dateOfBirth
		}, callback);
	}
	
	/**
	 * Shows an error.
	 *
	 * @param message the error message to show
	 */
	showError(message) {
		this.setState({
			showError: true,
			errorMsg: message
		});
		// Scroll up to the error message
		window.scrollTo(0, 0);
	}

	render() {
		let historyListComponent = (props) => {
			if (this.state.userInfo && this.state.userInfo.type === "myGDX" && props.match.path === "/order-history") {
				return (<div>
							<HistoryList
								setLoading={this.setLoading}
								setStep={this.setStep}
								userInfo={this.state.userInfo}
							/>
						</div>);
			}
			
			return null;
		};
		let loginComponent = (props) => {
			return <LoginOptions
						redirect={this.state.redirect}
						setUserInfo={this.setUserInfo}
					/>;
		};

		let searchComponent = <LandingPage
				userInfo={this.state.userInfo}
				showError={this.showError}
				setLoading={this.setLoading}
				setStep={this.setStep}
			/>;

		let orderComponent = (props) => {
			return (
				<Order
					userInfo={this.state.userInfo}
					showError={this.showError}
					setLoading={this.setLoading}
					setStep={this.setStep}
					breadcrumbStep={this.state.step}
				/>
			);
		};

		// don't render the router until the app is initialized. without this logic, a JWT nonce may be re-used in the
		// calls to fetch the requisition due to a race condition, resulting in a 401 response.
		const router = this.state.initialized
			? <Switch>
				<Route exact path={["/", "/kitordering"]}>{searchComponent}</Route>
				<Route exact path="/login" render={loginComponent} />
				<Route exact path="/order-history" render={historyListComponent} />
				<Route exact path="/order/:id/:step?" render={orderComponent} />
				<Route exact path="/order/:id/:step/:req" render={orderComponent} />
				<Route exact path="/register/:reqNum?">
					<PrcWrapper userInfo={this.state.userInfo} setUserInfo={this.setUserInfo}>{searchComponent}</PrcWrapper>
				</Route>
				<Route exact path="/view/:orderId"><PdfViewer /></Route>
				<Route exact path="/patient-management"><PatientManagementHome userInfo={this.state.userInfo} /></Route>
				<Route exact path="/recollect/:accessionNo"><Recollection /></Route>
				<Route exact path="/connect/:id?">
					<PrcWrapper userInfo={this.state.userInfo} setUserInfo={this.setUserInfo}>
						<PITLLandingPage userInfo={this.state.userInfo} setLoading={this.setLoading} />
					</PrcWrapper>
				</Route>
				<Route path={["/custom-profile/new/:gsdlNo", "/custom-profile/edit/:bundleId", "/custom-profile"]}>
					<ManageBundles />
				</Route>
			  </Switch>
			: null;

		return (
			<div>
				<div>
				{this.state.showError &&
					<div className="alert alert-danger" role="alert">
						<strong>{this.state.errorMsg}</strong>
					</div>
				}
				{router}
				</div>
				<div className="loading-shield" hidden={!this.state.loading}>
					<i className="fa fa-spinner fa-spin fa-fw loading-icon"></i>
				</div>
			</div>
		);
	}
}

export default App;
